import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as navigation from "../../utils/navigation.js";
import * as rwData from "../../utils/rwData.js";

const LinkTransparent = (props) => {
  //========================================================================
  // State für den "gedrückt" Zustand
  const [isPressed, setIsPressed] = useState(false);

  //========================================================================
  // Seite wechseln
  const handleInputChange = () => {
    if (props.authWrite) {
      navigation.changePage("custom", props.props.path);
    }
  };

  //========================================================================
  // Maus-Event-Handler
  const handleMouseDown = () => {
    setIsPressed(true);
  };

  const handleMouseUp = () => {
    setIsPressed(false);
    handleInputChange();
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleTouchStart = () => {
    setIsPressed(true);
  };

  const handleTouchEnd = () => {
    setIsPressed(false);
    handleInputChange();
  };

  //========================================================================
  // Grafische Darstellung
  return (
    <button
      style={{
        ...props.style,
        visibility: props.props.visibility,
        transform: `${props.element.transform} ${
          isPressed ? "scale(0.95)" : "scale(1)"
        }`,
        cursor: "pointer",
        transition: "transform 0.05s, box-shadow 0.05s",
        boxShadow: isPressed
          ? "inset 2px 2px 5px rgba(0,0,0,0.5)"
          : "2px 2px 5px rgba(0,0,0,0.3)",
        border: "solid 2px rgba(255, 255, 255, 0.2)",
        backgroundColor: "rgba(0, 0, 0, 0)",
        display: "flex",
      }}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      title={
        props.element.tooltip
          ? language.displayText(props.element.tooltip) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "")
          : language.displayText(props.props.text) +
            (props.element.tooltip2
              ? "\n" + language.displayText(props.element.tooltip2)
              : "") +
            (props.element.tooltip3
              ? "\n" + language.displayText(props.element.tooltip3)
              : "") +
            (globalVars.cyclicUpdate || globalVars.editor
              ? "\n" + ("Pfad: " + props.props.path)
              : "")
      }
    >
      <div
        style={{
          paddingLeft: "3%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          boxSizing: "border-box",
          maxWidth: `calc(${props.element.width} - 5%)`,
        }}
      ></div>
    </button>
  );
};

export default LinkTransparent;
